import { useEffect } from "react";
import { useStore } from "src/contexts/StoreContext";

export const useAddToCartStatus = () => {
  const {
    project: { listenForCartEvents, cleanupCartEvents },
  } = useStore();

  useEffect(() => {
    listenForCartEvents(); // Inizializza i listener degli eventi legati al carrello dello SDK

    return () => {
      cleanupCartEvents(); // Rimuove i listener degli eventi quando il componente si smonta
    };
  }, [listenForCartEvents, cleanupCartEvents]);
};
